import styled from 'styled-components';
import { Button } from '../../../../../../../components';
import { colors } from '../../../../../../../styles/theme';

export const ButtonStyled = styled(Button)`
  color: ${colors.color1};
`;
